<template>
  <section class="grid grid-cols-12 gap-x-4 gap-y-6">
    <rpm-input
        class="col-span-4"
        type="datetime-local"
        v-model="form.executed_at"
        label="Data de Execução"
        :errors="errors.executed_at"
        placeholder="Data de Execução"
    ></rpm-input>

    <rpm-input
        class="col-span-4"
        type="select"
        :options="collaborators"
        v-model="form.executor_id"
        optionValue="userid"
        optionLabel="name"
        label="Executor"
        :errors="errors.executor_id"
        placeholder="Executor"
    ></rpm-input>

    <rpm-input
        class="col-span-4"
        type="select"
        :options="sourceProcedureSituations"
        v-model="form.source_procedure_situation_id"
        optionValue="id"
        optionLabel="description"
        label="Situação"
        :errors="errors.source_procedure_situation_id"
        placeholder="Situação"
    ></rpm-input>
    <rpm-input
        class="col-span-4"
        type="select"
        :options="organizationsBySourceSituation"
        v-model="form.next_organization_id"
        optionValue="organization_id"
        optionLabel="organization_name"
        label="Próxima organização"
        :errors="errors.next_organization_id"
        placeholder="Próxima organização"
        v-if="organizationsBySourceSituation.length"
    ></rpm-input>
    <rpm-input
        class="col-span-4"
        type="select"
        :options="nextProcedureOwners"
        v-model="form.next_owner_id"
        optionValue="id"
        optionLabel="name"
        :label="next_owner_required ? 'Responsável *' : 'Responsável'"
        :errors="errors.next_owner_id"
        placeholder="Responsável"
        v-if="nextProcedureOwners"
    ></rpm-input>

    <rpm-input
        v-if="observation_required"
        class="col-span-12"
        type="editor"
        v-model="form.observation"
        label="Observação"
        :errors="errors.observation"
        placeholder="Observação"
    ></rpm-input>
    <section
        v-if="procedure.source_procedure.request_questionnaire"
        v-for="group in procedure.source_procedure.request_questionnaire.groups"
        class="flex flex-col gap-4 col-span-12"
    >
      <section class="flex flex-col gap-4 px-2">
        <questionnaire-form
            v-if="procedure?.source_procedure?.request_questionnaire"
            :questionnaire-object="procedure.source_procedure.request_questionnaire"
            @questionnaire-update="updateQuestionnaire"
        ></questionnaire-form>
      </section>
    </section>
  </section>
  <section class="flex flex-row justify-center gap-6">
    <rpm-button
      label="Salvar"
      @click="executeProcedure"
    ></rpm-button>
  </section>
</template>


<script>

import collaboratorRepository from "#repositories/collaboratorRepository";

import QuestionnaireForm from "#views/questionnaire/form.vue";
import procedureRepository from "#repositories/procedureRepository";
import sourceSituationStore from "#repositories/sourceSituationRepository";
import sourceProcedureSituationStore from '#repositories/sourceProcedureSituationRepository.js'
import sourceServiceProcedureOrganizationRepository from "#repositories/sourceServiceProcedureOrganizationRepository";

import {getErrors} from "#functions/validator";

import moment from "moment";
import _ from "lodash";

export default {
  name: "NotExecutedCase",
  emits: ["procedureExecuted"],
  components: {
    QuestionnaireForm
  },
  props: {
    procedure: {
      type: Object,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    proceduresIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      errors: {},
      collaborators: [],
      form: {
        current_organization_id: '',
        executor_id: '',
        next_organization_id: '',
        next_owner_id: null,
        observation: '',
        owner_id: '',
        questionnaire_answers: null,
        source_procedure_situation_id: '',
        executed_at: ''
      },
      observation_required: false,
      sourceProcedureSituations: [],
      organizationsBySourceSituation: [],
      nextProcedureOwners: null,
      next_owner_required: false,
      next_source_procedure: null,
      sourceProcedureOrganization: []
    };
  },
  methods: {
    async listCollaboratorsByOrganization() {

      if (!this.procedure.executed_at && this.procedure.organizations) {

        this.collaborators = [].concat(
            ...(await Promise.all(
                this.procedure.organizations.map(async (organization) => {
                  return (await collaboratorRepository.listByOrganizations(this.currentOrganization())).data;
                })
            ))
        );
      }

    },
    currentOrganization() {
      return this.$user.person.collaborator.organization.id;
    },
    getSourceServiceSituations() {
      sourceProcedureSituationStore.getSourceProcedureSituations(this.procedure.source_procedure.id).then((response) => {
        this.sourceProcedureSituations = []
        response.data.forEach((element) => {
          if (element.enabled) {
            this.sourceProcedureSituations.push({
              id: element.id,
              description: element.source_situation.description,
              observation_required: element.observation_required,
              next_source_procedure: element.next_source_procedure
            });
          }
        })
      })
    },
    updateQuestionnaire(questionnaire) {
      this.form.questionnaire_answers = questionnaire;
    }
    ,
    async executeProcedure() {
      if (!this.form.current_organization_id) {
        this.form.current_organization_id = this.currentOrganization()
      }

      if (this.procedure?.owner?.id) {
        this.form.owner_id = this.procedure.owner.id
      }

      (
        this.multiple ?
          procedureRepository.updateMultipleServiceProcedureExecution({
            procedures: this.proceduresIds,
            ...this.form
          })
            :
          procedureRepository.updateProcedure(this.procedure.id, this.form)
      ).then((response) => {
        this.$notify('Procedimento Executado', 'success');
        this.$emit('procedureExecuted', response.data);
      }).catch((response) => {
        this.$notify('Erro ao executar procedimento', 'error');
        getErrors(this.errors, response.errors);
      });
    }
    ,

  },
  mounted() {
    this.listCollaboratorsByOrganization();
    this.getSourceServiceSituations();
    this.form.executed_at = moment(new Date()).format('YYYY-MM-DD HH:mm')
    this.form.executor_id = this.$user.id
  },
  watch: {
    async 'form.source_procedure_situation_id'(val) {
      let situation = _.find(this.sourceProcedureSituations, (element) => {
        return element.id === val
      })
      this.observation_required = situation.observation_required

      let nextSourceProcedureBySituation = _.find(this.sourceProcedureSituations, {'id': val})


      const nextSourceProcedure = nextSourceProcedureBySituation.next_source_procedure
      const requiredOwnerOrganizations = nextSourceProcedure?.required_owner_organizations ?? []

      this.next_owner_required = requiredOwnerOrganizations.length > 0
      this.form.next_owner_id = null
      this.nextProcedureOwners = null

      if (nextSourceProcedure) {
        collaboratorRepository.listByOrganizations(val).then((response) => {
          this.nextProcedureOwners = response.data.length > 0 ? response.data : null
        })
      }
    },
  }
};
</script>
